import {Action, Selector, State, StateContext} from "@ngxs/store";
import {SchematicsStateModel} from "@app/stores/models/schematics-state-model";
import {Injectable} from "@angular/core";
import {ApiCommissioningSheetService} from "@app/services/apiservices/api-commissioning-sheet.service";
import {tap} from "rxjs/operators";
import {
  GetTemplateData,
  RemoveSelectedTreeItem,
  RemoveTemplateData,
  SetSelectedTreeItem
} from "@app/stores/actions/schematics-action";
import {SD_TreeModel} from "@app/routes/schematics/model/sd_tree-model";
import { UnitTemplateDataViewModel } from "@app/models/generatedmodels/UnitTemplateDataViewModel";

@State<SchematicsStateModel>({
  name: 'SchematicsState',
  defaults: {
    commissioningSheetTemplate : new UnitTemplateDataViewModel(),
    selectedTreeViewItem: new SD_TreeModel()
  }
})

@Injectable()
export class SchematicsState {
  constructor(private apiCommissioningSheetService: ApiCommissioningSheetService) {
  }

  //// SELECTORS ////
  @Selector()
  static getCommissioningSheetTemplate(state: SchematicsStateModel) {
    return state.commissioningSheetTemplate;
  }

  @Selector()
  static getSelectedTreeItem(state: SchematicsStateModel) {
    return state.selectedTreeViewItem;
  }

  //// ACTIONS ////
  @Action(GetTemplateData)
  getCommissioningSheetTemplate({getState, setState}: StateContext<SchematicsStateModel>, {id}) {
    return this.apiCommissioningSheetService.getCommissioningSheetTemplate(id).pipe(
      tap(result => {
        const state = getState();
        setState({
          ...state,
          commissioningSheetTemplate: result
        });
      })
    );
  }

  @Action(SetSelectedTreeItem)
  setSelectedTreeItemState({getState, setState}: StateContext<SchematicsStateModel>, {item}: SetSelectedTreeItem) {
    const state = getState();
    setState({
      ...state,
      selectedTreeViewItem: item,
    });
  }

  @Action(RemoveSelectedTreeItem)
  removeSelectedTreeItemState({getState, setState}: StateContext<SchematicsStateModel>) {
    const state = getState();
    setState({
      ...state,
      selectedTreeViewItem: new SD_TreeModel(),
    });
  }

  @Action(RemoveTemplateData)
  removeCommissioningSheetTemplateState({getState, setState}: StateContext<SchematicsStateModel>) {
    const state = getState();
    setState({
      ...state,
      commissioningSheetTemplate: new UnitTemplateDataViewModel(),
    });
  }
}
